export default "__VITE_ASSET__BhRfd6E5__"